import { MailItemCheckbox } from "./mail-item-checkbox";
import { Pagination } from "./pagination";

export class MailItem {
    variant: string;
    name: string;
    title: string;
    attachment: boolean;
    date: string;
    content?: string;
    checkbox: MailItemCheckbox;
    attachmentId: string;
    unread: boolean;
    threadId: number;
    fromAsp: boolean;
    policyNumber: string;
    claimNumber: string;
    dms2docId?: string;
    dms2docBrandId?: number;
    dms2docCatId?: number;
    dms2DocboxId?: number;
    dms2Actnumber: string | null;
    dms2Secflag: string | null;
}

export class MailItemList {
    list: MailItem[];
    pagination: Pagination;
    unreadMessagesCount: number;
}
